import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ArticleTableRow } from "./ArticleTableRow";

interface SpecialArticlesTableProps {
  articles: any[] | undefined;
  onDelete: (id: string, isSpecial: boolean) => void;
  deletingId: string | null;
}

export const SpecialArticlesTable = ({
  articles,
  onDelete,
  deletingId,
}: SpecialArticlesTableProps) => {
  return (
    <div className="rounded-lg border bg-card">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>タイトル</TableHead>
            <TableHead>スラッグ</TableHead>
            <TableHead>投稿日</TableHead>
            <TableHead className="text-right">操作</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {articles?.map((article) => (
            <ArticleTableRow
              key={article.id}
              id={article.id}
              title={article.title}
              slug={article.slug}
              createdAt={article.created_at}
              isSpecial={true}
              onDelete={onDelete}
              deletingId={deletingId}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};